// @flow @jsx h
import { h } from 'preact'
import { PureComponent } from '../../lib/pureComponent'
import type { MediaProps } from '../types'

type Props = {
  media: MediaProps,
  gaPropertyId?: string | null
}

export class Video extends PureComponent<Props, {}> {
  el: HTMLDivElement | null
  ludoInstance

  componentDidMount(): void {
    const mediaId = getMediaId(this.props.media.id)
    // $FlowFixMe
    require.ensure(['@nrk/ludo'], require => {
      const ludo = require('@nrk/ludo')
      this.ludoInstance = ludo(this.el, mediaId, {
        chromecast: {
          enabled: false
        },
        analytics: {
          ga: {
            trackingId: this.props.gaPropertyId
          }
        }
      })
      window.ld = this.ludoInstance
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.media.id !== prevProps.media.id && this.ludoInstance) {
      const mediaId = getMediaId(this.props.media.id)
      this.ludoInstance
        .cue(mediaId)
        // Ludo doesn't update the poster element when calling `cue()`, so we
        // need to manually update it
        .then(() => this.updatePoster())
        .catch(err => console.error(err))
    }
  }

  updatePoster() {
    const posterEl = this.el.querySelector('.ludo-poster > img')
    const playbackSession = this.ludoInstance.getPlaybackSession()
    try {
      const { images } = playbackSession.current.metadata.preplay.poster
      const srcSet = buildSrcSet(images)
      posterEl.setAttribute('srcset', srcSet)
      posterEl.setAttribute('src', images.unshift().url)
    } catch (err) {
      // If the `images` array on the playback session does not exist,
      // fail gracefully, log the error, and clear the `src` and `srcset` attributes
      console.error(err)
      posterEl.setAttribute('srcset', '')
      posterEl.setAttribute('src', '')
    }
  }

  render() {
    return <div ref={el => (this.el = el)} />
  }
}

function buildSrcSet(images) {
  return images.map(({ url, pixelWidth }) => `${url} ${pixelWidth}w`).join(',')
}

function getMediaId(id: string): string {
  return id.indexOf('klipp:') > -1 ? extractIdFromSmartUrl(id) : id
}

function extractIdFromSmartUrl(smartUrl: string): string {
  return smartUrl.substr(smartUrl.lastIndexOf('/') + 1, smartUrl.length)
}



// WEBPACK FOOTER //
// ./src/v1/components/Video.js